import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "upsell-buttons",
    templateUrl: "upsell-buttons.html",
    standalone: false
})

export class UpsellButtonsComponent {

  @Input() buttonYesText: string = `YES I WANT THIS SPECIAL ADDED TO MY ORDER`;
  @Input() buttonNoText: string = `NO THANKS, I UNDERSTAND THAT I WON'T SEE THIS OFFER AGAIN`;

  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  nextPage(buttonValue: boolean) {
    this.eventEmitter.emit(buttonValue);
  }
}
